import React,{useContext, useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom'
import axios from 'axios'

import { toAbsoluteUrl } from "../../../helpers/CommonFunction";

import AppContext from '../../../../app/routing/AuthContext';

import { getLocalStrogeValue } from '../../../../app/component/common/Helper';


const HeaderUserMenu = () => {
    const api_base_url = process.env.REACT_APP_API_URL;
    const agentInfo = JSON.parse(localStorage.getItem('agentInfo'));
    const authCtx = useContext( AppContext );

    const logoutHandler = async() => {
        if(localStorage.getItem('type') === "E") {
            const api_headers = {
                headers: { 
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "x-access-token" : localStorage.getItem('agenttoken')
                }
            };
            await axios.post(`${api_base_url}api/agent-logout`, { agent_id: agentInfo.unique_id}, api_headers)
            .then(async (res) => {
                if(res.data.status === 'success') {
                    authCtx.logout({
                        type: localStorage.getItem('type')
                    });
                }
            })
            .catch((error) => {
                console.error(error);
            })
        } else {
            authCtx.logout({
                type: localStorage.getItem('type')
            });
        }
    }

    const loginInfo = localStorage.getItem('agentInfo');
    const loginType = localStorage.getItem('type');
    const devLoginInfo = localStorage.getItem('developerinfo');

    const [ headerDetails, setHeaderDetails ] = useState({
        user_name: '',
        email : ''
    })
    useEffect(() => {
        if(loginType === 'A'){
            setHeaderDetails({
                user_name: localStorage.getItem('business_name'),
                email: localStorage.getItem('business_email')
            })
        }
        else if(loginType === 'E'){
            const jpLoginInfo = JSON.parse(loginInfo)
            setHeaderDetails({
                user_name: jpLoginInfo.agent_name,
                email: jpLoginInfo.agent_email
            })
        }
        else if(loginType === 'D'){
            const jpDevLoginInfo = JSON.parse(devLoginInfo);
            setHeaderDetails({
                user_name: jpDevLoginInfo.user_full_name,
                email: jpDevLoginInfo.user_email
            });
        }
    },[loginInfo])
    return (
        <div
            className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
            data-sai-menu='true'
        >
            <div className='menu-item px-3'>
                <div className='menu-content d-flex align-items-center px-3'>
                    <div className='symbol symbol-50px me-5'>
                        <img alt='Logo' src={toAbsoluteUrl('media/avatars/300-1.jpg')} />
                    </div>
                    <div className='d-flex flex-column'>
                        <div className='fw-bolder d-flex align-items-center fs-5'>
                            { headerDetails.user_name }
                            {
                                loginType === 'SA' &&
                                <span className="badge badge-light-success fw-bold fs-8 px-2 py-1 ms-2">
                                    System Admin
                                </span>
                            }
                        </div>
                        <div className='fw-bold text-muted fs-7 mt-1'>
                            { headerDetails.email }
                        </div>
                    </div>
                </div>
            </div>
            <div className='separator my-2'></div>
            {
                loginType === 'A' &&
                <div className='menu-item px-5'>
                    <Link to={'/settings/business-setup'} className='menu-link px-5'>
                        Business Profile 
                    </Link>
                </div>
            }
            {
                loginType === 'D' &&
                <div className='menu-item px-5'>
                    <Link to={'/profile'} className='menu-link px-5'>
                        Profile 
                    </Link>
                </div>
            }
            <div className='menu-item px-5'>
                <a className='menu-link px-5' onClick={logoutHandler}>
                    Sign Out
                </a>
            </div>
        </div>
    )
}

export default HeaderUserMenu;